import { render, staticRenderFns } from "./DataTableCustomer.vue?vue&type=template&id=3ea3db4d"
import script from "./DataTableCustomer.vue?vue&type=script&lang=js"
export * from "./DataTableCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports